(function(){
  'use strict';

  var SELECTOR='[data-laf-delivery]';
  var CUT_OFF_MINUTES=14*60;
  var LOCALE='fr-FR';
  var ZONE='Europe/Paris';

  function parisParts(now){
    var parts=new Intl.DateTimeFormat('en-GB',{
      timeZone:ZONE,year:'numeric',month:'2-digit',day:'2-digit',
      weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'
    }).formatToParts(now);
    var out={};
    parts.forEach(function(p){ if(p.type!=='literal') out[p.type]=p.value; });
    return {
      year:Number(out.year),month:Number(out.month),day:Number(out.day),
      hour:Number(out.hour),minute:Number(out.minute),weekday:out.weekday
    };
  }

  function dateOnly(y,m,d){ return new Date(Date.UTC(y,m-1,d,12,0,0)); }
  function addDays(date,n){ var d=new Date(date.getTime()); d.setUTCDate(d.getUTCDate()+n); return d; }
  function dayIndex(date){ return date.getUTCDay(); } // 0 dim, 6 sam
  function isTransportDay(date){ return dayIndex(date)!==0; } // lundi-samedi
  function isStandardDeliveryDay(date){ return dayIndex(date)!==0; } // estimation colis: lundi-samedi

  function nextDispatchDate(today,beforeCutoff){
    var day=dayIndex(today);
    if(day===0) return addDays(today,1); // dimanche -> lundi
    if(beforeCutoff) return today;      // lun-sam avant 14h
    var candidate=addDays(today,1);     // après 14h
    while(!isTransportDay(candidate)) candidate=addDays(candidate,1);
    return candidate;
  }

  function addBusinessDays(start,count){
    var d=new Date(start.getTime());
    var added=0;
    while(added<count){
      d=addDays(d,1);
      if(isStandardDeliveryDay(d)) added++;
    }
    return d;
  }

  function fmtLong(date){
    return new Intl.DateTimeFormat(LOCALE,{weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}).format(date);
  }
  function fmtDayMonth(date){
    return new Intl.DateTimeFormat(LOCALE,{weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}).format(date);
  }
  function fmtDeliveryRange(a,b){
    var aMonth=a.getUTCMonth(), bMonth=b.getUTCMonth();
    if(aMonth===bMonth){
      var left=new Intl.DateTimeFormat(LOCALE,{weekday:'long',day:'numeric',timeZone:'UTC'}).format(a);
      var right=new Intl.DateTimeFormat(LOCALE,{weekday:'long',day:'numeric',month:'long',timeZone:'UTC'}).format(b);
      return left+' – '+right;
    }
    return fmtDayMonth(a)+' – '+fmtDayMonth(b);
  }
  function sameDay(a,b){ return a.getUTCFullYear()===b.getUTCFullYear()&&a.getUTCMonth()===b.getUTCMonth()&&a.getUTCDate()===b.getUTCDate(); }
  function cap(s){ return s ? s.charAt(0).toUpperCase()+s.slice(1) : s; }

  function render(el){
    var now=new Date();
    var p=parisParts(now);
    var today=dateOnly(p.year,p.month,p.day);
    var beforeCutoff=(p.hour*60+p.minute)<CUT_OFF_MINUTES;
    var dispatch=nextDispatchDate(today,beforeCutoff);
    var expressMin=addBusinessDays(dispatch,1);
    var expressMax=addBusinessDays(dispatch,2);
    var relayMin=addBusinessDays(dispatch,2);
    var relayMax=addBusinessDays(dispatch,4);
    var dispatchToday=sameDay(dispatch,today);

    var title=el.querySelector('[data-laf-delivery-title]');
    var lead=el.querySelector('[data-laf-delivery-lead]');
    var badge=el.querySelector('[data-laf-delivery-badge]');
    var orderDate=el.querySelector('[data-laf-order-date]');
    var shipDate=el.querySelector('[data-laf-ship-date]');
    var deliveryDate=el.querySelector('[data-laf-delivery-date]');
    var deliveryNote=el.querySelector('[data-laf-delivery-note]');

    if(dispatchToday){
      title.textContent='Expédition aujourd’hui';
      lead.textContent='Commandez avant 14h : votre colis est préparé et expédié le jour même.';
      if(badge){
        badge.querySelector('.laf-delivery__badge-main').textContent='AVANT 14H';
        badge.querySelector('.laf-delivery__badge-sub').textContent='départ aujourd’hui';
      }
    }else{
      title.textContent='Expédition '+fmtLong(dispatch);
      if(dayIndex(today)===0){
        lead.textContent='Votre commande est préparée aujourd’hui et expédiée dès lundi.';
      }else if(dayIndex(today)===6 && !beforeCutoff){
        lead.textContent='Votre commande est préparée aujourd’hui et expédiée dès lundi.';
      }else{
        lead.textContent='Votre commande est préparée aujourd’hui et expédiée dès le prochain jour d’expédition.';
      }
      if(badge){
        badge.querySelector('.laf-delivery__badge-main').textContent='LUN–DIM';
        badge.querySelector('.laf-delivery__badge-sub').textContent='préparation 7j/7';
      }
    }

    if(orderDate) orderDate.textContent=cap(fmtDayMonth(today));
    if(shipDate) shipDate.textContent=dispatchToday ? 'Aujourd’hui' : cap(fmtDayMonth(dispatch));
    if(deliveryDate) deliveryDate.textContent='Express : '+cap(fmtDeliveryRange(expressMin,expressMax));
    if(deliveryNote) deliveryNote.textContent='Point relais : '+cap(fmtDeliveryRange(relayMin,relayMax));
  }

  function init(){ document.querySelectorAll(SELECTOR).forEach(render); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();

  // Recalcule régulièrement pour basculer proprement à 14h / minuit sans recharger la page.
  window.setInterval(init,60000);
})();
